import api from './api';

export const authService = {
  /**
   * Verify Firebase ID token with backend
   */
  async verifyToken(idToken) {
    const response = await api.post('/auth/verify-firebase-token', {
      id_token: idToken,
    });
    return response.data;
  },

  /**
   * Get current user profile
   */
  async getCurrentUser() {
    const response = await api.get('/users/me');
    return response.data;
  },
};









